import { css } from "@linaria/core";

export const errorCls = css`
  display: flex;
  flex-direction: column;
  align-items: center;

  --margin-left: min(55px, var(--white-space-size, 0px));

  position: absolute;
  top: calc(50% + 30px);
  left: calc(var(--margin-left) + 20px);
  width: calc(100% - 40px - var(--margin-left) - var(--white-space-size, 0px));
  transform: translateY(-50%);
`;

export const iconCls = css`
  color: var(--color-primary, var(--portal--color-secondary));
`;

export const textCls = css`
  font-family: var(--font-family, var(--brand--font));
  font-size: calc(24 * var(--font-px, 1px));
  font-weight: 400;
  color: #000;
`;

export const buttonCls = css`
  -webkit-appearance: none;
  background: transparent;
  outline: none;
  border: none;
  margin: 0;
  padding: 0;
  cursor: pointer;
`;

export const buttonTextCls = css`
  font-family: var(--font-family, var(--brand--font));
  font-size: calc(16 * var(--font-px, 1px));
  font-weight: 400;
  color: var(--color-primary, var(--portal--color-secondary));

  .${buttonCls}:hover & {
    text-decoration: underline;
  }
`;

export const loadingEllipsisCls = css`
  opacity: 0;

  /* use pseudo layers to help render ellipsis */
  &::before,
  &::after {
    content: ".";
  }

  &.active {
    opacity: 1;
    animation: dot2 900ms linear infinite;

    &::before {
      animation: dot1 900ms linear infinite;
    }

    &::after {
      animation: dot3 900ms linear infinite;
    }
  }

  /**
   * animation sequence to fade the dots into view one by one, before fading
   * them all out again so we can repeat the process
   */
  @keyframes dot1 {
    from {
      color: rgba(0, 0, 0, 0);
    }

    25% {
      color: rgba(0, 0, 0, 1);
    }

    75% {
      color: rgba(0, 0, 0, 1);
    }

    to {
      color: rgba(0, 0, 0, 0);
    }
  }

  @keyframes dot2 {
    from {
      color: rgba(0, 0, 0, 0);
    }

    25% {
      color: rgba(0, 0, 0, 0);
    }

    50% {
      color: rgba(0, 0, 0, 1);
    }

    75% {
      color: rgba(0, 0, 0, 1);
    }

    to {
      color: rgba(0, 0, 0, 0);
    }
  }

  @keyframes dot3 {
    from {
      color: rgba(0, 0, 0, 0);
    }

    50% {
      color: rgba(0, 0, 0, 0);
    }

    75% {
      color: rgba(0, 0, 0, 1);
    }

    to {
      color: rgba(0, 0, 0, 0);
    }
  }
`;
